import { Compass } from "lucide-react";

import { cameFromChip, type CameFromSubject } from "@/lib/cameFrom";

/**
 * "Came from: Google Ads · 'backflow test fort worth'" — or, when the office
 * asked the caller, "Heard about us: City notice or letter". Renders nothing
 * when we don't know, so older records stay quiet.
 */
export function CameFromChip({
    subject,
    className = "",
}: {
    subject: CameFromSubject | null | undefined;
    className?: string;
}) {
    const chip = cameFromChip(subject);
    if (!chip) return null;
    return (
        <span
            data-testid="came-from-chip"
            title={chip.title}
            className={`inline-flex max-w-full items-center gap-1 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-800 dark:border-indigo-800 dark:bg-indigo-950 dark:text-indigo-200 ${className}`}
        >
            <Compass className="h-3 w-3 shrink-0" aria-hidden />
            <span className="truncate">{chip.text}</span>
        </span>
    );
}
